import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const accountSpmStatisticsTabContent = EntityContentBlueprint.make({
  name: 'account-spm-statistics',
  params: {
    path: '/statistics',
    title: 'Statistics',
    group: 'statistics',
    filter: { kind: 'Account' },
    loader: () =>
      import('./components').then(m => <m.AccountSpmStatisticsTab />),
  },
});

export default [accountSpmStatisticsTabContent];
